var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentOption1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7596_60513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 9.33184V4.66634C28.5 3.37717 27.4558 2.33301 26.1667 2.33301H2.83333C1.54417 2.33301 0.5 3.37717 0.5 4.66634V9.33184H28.5Z",
    fill: "#49494A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.833V23.333C0.5 24.6222 1.54417 25.6663 2.83333 25.6663H26.1667C27.4558 25.6663 28.5 24.6222 28.5 23.333V12.833H0.5ZM13.3333 19.833H5.16667V17.4997H13.3333V19.833ZM23.8333 19.833H19.1667V17.4997H23.8333V19.833Z",
    fill: "#49494A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7596_60513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentOption1);
export default __webpack_public_path__ + "static/media/payment-option-1.bc490dacdaa7558e0741ded0732f1750.svg";
export { ForwardRef as ReactComponent };